<template>
  <PropertyComponentProvider>
    <ListContainer
      v-bind="$attrs"
      :module-name="moduleName"
      :resource-id="resourceId"
      :resource="resource"
      v-on="$listeners"
    />
  </PropertyComponentProvider>
</template>

<script>
import PropertyComponentProvider from './property-component-provider'
import ListContainer from './list-container'
export default {
  name: 'PropertyComponentListContainer',
  components: { PropertyComponentProvider, ListContainer },
  inheritAttrs: false,
  props: {
    resourceId: { type: Number, required: true },
    resource: { type: Object, required: true },
    moduleName: { type: String, required: true },
  },
}
</script>
